<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="min-width: 54em; width: 54em; max-height: 65vh;">
                <div class="modal-header" style="padding:15px 25px !important; padding-bottom: 0 !important;">
                    <h3 class="form-header" style="margin-left: 10px;">Dispense Information</h3>
                    <button @click.stop="closeModal()" class="red-close-button">
                        <i class="pi pi-times" style='padding: 0'></i>
                    </button>
                </div>
                <div class="modal-body" style="padding: 0 25px;">
                    <slot name="body">
                        <div class="label-with-icon">
                            <i class="pi pi-exclamation-circle"></i>
                            <label>
                                The medication selected is being dispensed against the provided chart. The action does not affect the current stock levels of the medication.
                            </label>
                        </div>

                        <div class="action-modal" 
                            style="display: grid; grid-template-columns: 220px 1fr; grid-gap: 10px; padding: 0;">
                            <!-- BASIC INFO -->
                            <!-- BASIC INFO -->

                                <div style="margin-left: 10px;">

                                    <div style="display: grid; grid-template-columns: 1fr; grid-gap: 15px; width: 37.8em;">
                                        <div style="margin-top: 20px; min-width: 50em;">
                                            <h3 style="text-align: left; margin: 0; margin-bottom: 10px; font-size: 1em;">Status: <span :style="reviewedPrescription.dispensed_items && reviewedPrescription.dispensed_items.length ? {color: 'green'}:{ color: 'red'}">{{ reviewedPrescription.dispensed_items && reviewedPrescription.dispensed_items.length ? 'Dispensed' : 'Not Dispensed'  }}</span> </h3>
                                            <p style="text-align: left; font-size: 1em;" v-if="reviewedPrescription.dispensed_items && reviewedPrescription.dispensed_items.length"><b>Dispensed Item/s:</b> <span v-for="(item,index) in reviewedPrescription.dispensed_items" :key="index">{{ item.name }}<b>{{ index+1 !=  reviewedPrescription.dispensed_items.length ? ' | ':''}}</b></span></p>
                                            <p style="text-align: left; font-size: 1em;" v-if="authorityNumber"><b>{{ authorityNumberLabel }}:</b> {{ authorityNumber }}</p>
                                            <div style="display: flex; flex-direction: column; gap: 5px;">
                                                <div style="display: flex; align-items: center; gap: 10px;">
                                                    <!-- <Dropdown v-model="stock" ref="med" @change="drugSelect(stock)" @keyup="debounceSearchDrugs(stock), show()" :loading="loadingDrugs" :options="drugList" optionLabel="full_name" :editable="true"
                                                    style="width: 100%; display: flex" placeholder="Select Medication" /> -->
                                                    <!-- <Dropdown v-if="this.$store.state.user.role.permissions.includes('can_edit_chart')" style="width: 50%;max-width: 21em; display: flex" id="pharmacy-med-list" placeholder="Select Medication" v-model="stock" optionValue="id" :options="formattedDrugList" optionLabel="full_name" :loading="loadingDrugs" /> -->
                                                    <div style="display: flex; align-items: center; gap: 10px; max-width: 46.5em">
                                                        <!-- <Dropdown :loading="loadingGroups" style="width: 10em; display: flex"
                                                        v-model="selectedPackSize" :options="packGroups" @change="getAMTMeds(true)" placeholder="Select Pack Size"  /> -->
                                                        <!-- v-if="drugList.length" -->
                                                        <Dropdown v-if="this.$store.state.user.role.permissions.includes('can_edit_chart') && !reviewedPrescription.expired"  v-model="selectedCTPP" ref="med" @change="drugSelect(selectedCTPP)" 
                                                        @keyup="debounceSearchDrugs(selectedCTPP), show()" :options="formattedDrugList"  optionLabel="name"
                                                        :loading="loadingDrugs"  :editable="true"
                                                        style="min-width: 18em; display: flex" placeholder="Select Pack" >
                                                            <template #option="slotProps">
                                                                <div>
                                                                    <b>{{ slotProps.option.name }}</b>
                                                                    <span v-if="slotProps.option.ctpp && slotProps.option.ctpp !== slotProps.option.name"> &ndash; <i>{{ slotProps.option.ctpp }}</i></span>
                                                                </div>
                                                            </template>
                                                        </Dropdown>
                                                        
                                                        <Dropdown v-if="selectedCTPP && selectedCTPP.drugs && selectedCTPP.drugs.length > 1 && (this.$store.state.user.role.permissions.includes('can_edit_chart'))" 
                                                            style="min-width: 24em; max-width: 24em; display: flex" placeholder="Select dispensed item" v-model="stock"
                                                            :options="selectedCTPP.drugs" optionLabel="name" :disabled="reviewedPrescription.expired" />
                                                        <p v-if="selectedCTPP && selectedCTPP.drugs && selectedCTPP.drugs.length == 1 && (this.$store.state.user.role.permissions.includes('can_edit_chart'))" style="font-size: 1em;"><b>Dispensing:</b> {{ stock.name }}</p>
                                                    </div>
                                                    <p style="text-align: left; font-size: 1em; margin: 0; margin-bottom: 10px;" v-if="!this.$store.state.user.role.permissions.includes('can_edit_chart')"><b>Packed/Non-Packed:</b> {{ packStatus ? packStatus : 'N/A' }}</p>
                                                </div>
                                                <span style="text-align: left; font-size:12px; margin-top:15px"><b>Pack Type</b></span>
                                                <Dropdown v-if="this.$store.state.user.role.permissions.includes('can_edit_chart')" @disabled="reviewedPrescription.expired" name="packed-status" placeholder="Select Pack Type" :options="actionTypes" v-model="packStatus" style="text-align: left; background-color: #E5F1FE"/>
                                                
                                                <span style="text-align: left; font-size:12px; margin-top:15px"><b>Administration Options</b></span>
                                                <div style="display: grid; grid-template-columns: repeat(3, 1fr); grid-gap: 10px; max-width: 50em">
                                                    <ToggleButton :disabled="!this.$store.state.user.role.permissions.includes('can_edit_chart') || reviewedPrescription.expired" v-model="do_not_crush" aria-label="DO NOT CRUSH" onLabel="DO NOT CRUSH" offLabel="DO NOT CRUSH" style="width:100%"/>
                                                    <ToggleButton :disabled="!this.$store.state.user.role.permissions.includes('can_edit_chart') || reviewedPrescription.expired" v-model="unusual_dose" aria-label="UNUSUAL DOSE" onLabel="UNUSUAL DOSE" offLabel="UNUSUAL DOSE" style="width:100%"/>
                                                    <ToggleButton :disabled="!this.$store.state.user.role.permissions.includes('can_edit_chart') || reviewedPrescription.expired" v-model="unusual_qty" aria-label="UNUSUAL QTY" onLabel="UNUSUAL QTY" offLabel="UNUSUAL QTY" style="width:100%"/>
                                                </div>
                                                <div style="background-color: rgb(229, 241, 254);border-radius: 6px; margin-top: 10px;">
                                                    <p class="note-header" style="margin: 0; padding-bottom: 5px;">Notes</p>
                                                    <textarea name="notes" id="note-modal" rows="5"
                                                    :placeholder="notes ? notes : 'No notes available.'" :disabled="!this.$store.state.user.role.permissions.includes('can_edit_chart') || reviewedPrescription.expired"
                                                    style="width: 100%;border-radius: 6px; border-top-right-radius: 0px; border-top-left-radius: 0px; border: none; background-color: #E5F1FE; padding: 0 8px;"
                                                    v-model="notes"></textarea>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                        </div>
                        <!-- <div v-else>
                            <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 10px;"></i>
                        </div> -->
                    </slot>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 0 25px !important; height: 3.5em; margin-top: 15px">
                    <slot name="footer" style="display: flex;">
                        <button class="green-button" @click="submitReview()" v-if="this.$store.state.user.role.permissions.includes('can_edit_chart') && !reviewedPrescription.expired" style="font-weight: bold">Update</button>
                        <Button class="black-button" 
                        style="  margin-left: 10px; text-align: center; overflow: hidden; "
                        @click="viewFMhrFile">
                        <svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26 13.0711C24.809 14.1963 23.6139 15.3182 22.4294 16.4494C22.2036 16.665 21.9883 16.8606 21.6337 16.8027C21.5248 16.7103 21.5581 16.5866 21.5581 16.4741C21.5551 15.573 21.5576 14.6714 21.5546 13.7702C21.5546 13.6731 21.5989 13.5369 21.4939 13.4911C21.3845 13.4435 21.3149 13.5756 21.2353 13.6353C20.8325 13.9373 20.5426 14.3456 20.1522 14.6588C20.0065 14.7754 19.8961 14.9411 19.6852 14.9738C19.6808 14.8753 19.5952 14.8291 19.5326 14.7703C19.0184 14.2854 18.5017 13.8033 17.987 13.3185C17.7199 13.0669 17.7174 12.8891 17.981 12.6413C19.1576 11.5357 20.3347 10.4316 21.5128 9.32788C21.7789 9.07867 21.9689 9.07914 22.2304 9.32414C23.3966 10.4176 24.5608 11.5124 25.73 12.6026C25.8374 12.7024 25.9035 12.8261 25.9995 12.9306V13.0706L26 13.0711Z" fill="#D3D3D3"/>
                            <path d="M17.4514 20.9594C17.4514 20.9729 17.4514 20.9865 17.4494 20.9995H17.3002C17.0909 20.8614 16.9198 20.6841 16.7403 20.5156C15.6691 19.5122 14.5984 18.5079 13.5287 17.5032C13.2223 17.2152 13.2213 17.0636 13.5227 16.7807C14.6864 15.6883 15.8501 14.5962 17.0143 13.5042C17.3146 13.2223 17.4768 13.2251 17.7851 13.5112C18.3669 14.0507 18.9498 14.5892 19.5316 15.1282C19.5495 15.153 19.5515 15.1782 19.5381 15.2052C19.3929 15.4045 19.1979 15.4908 18.9393 15.4414C18.7628 15.4073 18.6141 15.4586 18.4868 15.5767C18.2043 15.8395 17.9248 16.1045 17.6424 16.3673C17.5081 16.4923 17.4703 16.6421 17.4708 16.813C17.4743 18.1267 17.4673 19.4399 17.4753 20.7536C17.4753 20.8231 17.4882 20.8936 17.4519 20.9594H17.4514Z" fill="#EE4120"/>
                            <path d="M0.0407788 16.9021L0.0188975 16.9063L0 16.8956V13.444C0.0154164 13.444 0.0303355 13.4431 0.0452545 13.4403C0.141731 13.5252 0.128801 13.6381 0.129299 13.7445C0.132283 14.6966 0.132283 15.6481 0.129299 16.6001C0.129299 16.7061 0.142229 16.8199 0.0412761 16.9021H0.0407788Z" fill="#74AC8E"/>
                            <path d="M4.12606 21C4.12705 20.9869 4.12705 20.9739 4.12606 20.9608C4.15092 20.9239 4.18971 20.9113 4.23248 20.9053C4.29116 20.9029 4.34487 20.9113 4.38117 20.9613C4.37919 20.9743 4.3772 20.9874 4.37471 21H4.12606Z" fill="#BCDB9A"/>
                            <path d="M10.7934 10.9463C10.8918 10.9132 10.9505 10.8343 11.0202 10.7694C11.5483 10.2766 12.0734 9.78102 12.6016 9.28821C12.8458 9.06047 13.0357 9.05953 13.2829 9.29101C14.4724 10.404 15.661 11.5185 16.848 12.6343C17.1012 12.8723 17.0982 13.0506 16.8421 13.2909C15.6605 14.4007 14.4774 15.509 13.2948 16.6179C13.163 16.7411 13.0288 16.8592 12.8209 16.7602C12.8806 15.6131 12.8383 14.4651 12.8433 13.3175C12.8438 13.2013 12.8229 13.0856 12.7697 12.9782C12.7189 12.8434 12.617 12.743 12.5121 12.6432C11.9407 12.0967 11.3434 11.574 10.7909 11.0093C10.7805 10.9879 10.7814 10.9669 10.7934 10.9463Z" fill="#32A1DA"/>
                            <path d="M4.38116 20.9608C4.32795 20.9566 4.27473 20.9524 4.22152 20.9482C4.17428 20.8348 4.20511 20.7177 4.20511 20.6024C4.20312 19.3769 4.19964 18.1514 4.2076 16.9259C4.20909 16.6837 4.13748 16.4933 3.94651 16.3271C3.67996 16.0952 3.42833 15.8479 3.17271 15.6052C3.04192 15.481 2.8987 15.4129 2.70674 15.4512C2.45908 15.5002 2.27011 15.4134 2.13832 15.2127C2.12489 15.187 2.1239 15.1604 2.13584 15.1338C2.71768 14.593 3.29952 14.0525 3.88137 13.5117C4.17726 13.2363 4.33789 13.2349 4.6308 13.5093C5.79598 14.6014 6.96067 15.6939 8.12535 16.7863C8.43616 17.078 8.43716 17.2185 8.13082 17.506C6.96663 18.5989 5.80195 19.6914 4.63727 20.7835C4.56218 20.8539 4.49603 20.9379 4.38215 20.9603L4.38116 20.9608Z" fill="#8BC440"/>
                            <path d="M17.3848 10.3634C17.3848 9.72642 17.3892 9.0894 17.3818 8.45238C17.3793 8.25964 17.4429 8.1117 17.5921 7.97823C17.8915 7.71036 18.1844 7.43502 18.4699 7.15361C18.6041 7.02107 18.7553 6.95854 18.9363 7.01641C19.1537 7.08594 19.2949 7.00101 19.4396 6.8638C20.0448 6.28932 20.656 5.7195 21.2667 5.15015C21.3458 5.07642 21.4224 4.95695 21.5541 5.01575C21.671 5.06755 21.6292 5.19449 21.6292 5.29156C21.6312 6.30939 21.6277 7.32675 21.6322 8.34458C21.6337 8.65025 21.5203 8.90366 21.2926 9.1174C20.1035 10.2318 18.915 11.3472 17.7254 12.4612C17.6573 12.5251 17.5906 12.6254 17.4797 12.5872C17.3519 12.5428 17.3867 12.4178 17.3862 12.3216C17.3838 11.6692 17.3848 11.0163 17.3848 10.3639V10.3634Z" fill="#F6931E"/>
                            <path d="M8.45057 16.7093C8.371 16.6417 8.28845 16.5773 8.21236 16.5063C7.08697 15.4521 5.96207 14.3969 4.83816 13.3409C4.76257 13.2699 4.69544 13.191 4.62482 13.1154C4.52238 12.9278 4.58305 12.7696 4.72876 12.6306C5.26833 12.1153 5.81487 11.6062 6.3609 11.0971C6.45788 11.0065 6.5643 10.9641 6.69559 11.0289C6.83533 11.098 6.98054 11.0971 7.13123 11.0681C7.24958 11.0453 7.37093 11.0565 7.46243 11.1302C7.88116 11.4676 8.26657 11.8367 8.62463 12.232C8.58136 12.1653 8.58235 12.0859 8.58235 12.0066C8.58235 11.1988 8.58186 10.391 8.58285 9.58268C8.58285 9.49774 8.5744 9.40861 8.62313 9.33207C8.66988 9.2588 8.71265 9.28587 8.74597 9.34747C8.77382 9.41421 8.7773 9.48421 8.7773 9.55375C8.77929 10.523 8.78128 11.4923 8.7763 12.4616C8.7763 12.5237 8.77034 12.5858 8.75741 12.6469C8.70469 12.7902 8.72757 12.9376 8.72757 13.0846C8.73005 14.1701 8.73005 15.2556 8.72757 16.3407C8.72757 16.4261 8.72757 16.5124 8.69325 16.5931C8.64949 16.6981 8.58484 16.7705 8.44958 16.7093H8.45057Z" fill="#BEBEBE"/>
                            <path d="M8.69093 9.29147C8.62031 9.37361 8.65214 9.47068 8.65164 9.56075C8.64915 10.4806 8.65015 11.4009 8.65015 12.3375C8.28761 11.9287 7.88082 11.5913 7.50337 11.2282C7.39098 11.1204 7.2572 11.0863 7.09558 11.1372C6.94987 11.1829 6.79571 11.1811 6.67088 11.0854C6.5759 11.0126 6.51771 11.035 6.44163 11.1064C5.88216 11.6347 5.3217 12.162 4.75776 12.6861C4.62498 12.8098 4.61305 12.9572 4.62498 13.1154C4.45242 12.9241 4.37782 12.6982 4.37732 12.4528C4.37484 11.4368 4.37633 10.4208 4.37583 9.40534C4.37583 9.30407 4.35992 9.18694 4.47629 9.1384C4.60907 9.08333 4.68615 9.1944 4.76472 9.26767C5.3217 9.78709 5.87968 10.3051 6.4287 10.832C6.54805 10.9463 6.6132 10.9552 6.73703 10.8352C7.27312 10.3186 7.82313 9.81462 8.36271 9.30081C8.4751 9.19347 8.58948 9.12347 8.75408 9.1566C8.77398 9.21867 8.7506 9.26254 8.69043 9.29147H8.69093Z" fill="#D3D3D3"/>
                            <path d="M8.45065 16.7093C8.66399 16.7075 8.64808 16.5586 8.64858 16.4289C8.65057 15.5538 8.64957 14.6788 8.64957 13.8038C8.64957 13.4939 8.64808 13.1845 8.65057 12.8746C8.65106 12.7995 8.6252 12.7183 8.69085 12.653C8.81119 12.7421 8.80125 12.8933 8.88181 13.0016C8.93254 13.1019 9.01807 13.1756 9.09963 13.2526C9.61931 13.7403 10.1395 14.2275 10.6582 14.7157C10.7278 14.781 10.8069 14.8394 10.8521 14.9252C10.8586 14.9486 10.8521 14.9682 10.8342 14.9845C10.2355 15.5394 9.63721 16.0947 9.03697 16.6482C8.8286 16.8405 8.68637 16.8531 8.45065 16.7098V16.7093Z" fill="#D3D3D3"/>
                            <path d="M8.84461 13.03C8.74515 12.9218 8.72128 12.786 8.69095 12.653C8.69095 11.5325 8.69095 10.412 8.69095 9.29194C8.71233 9.24714 8.73322 9.20187 8.7546 9.15707C8.89136 9.13653 8.96446 9.22894 9.04503 9.30454C9.62836 9.85149 10.2107 10.3989 10.794 10.9463C10.7945 10.9575 10.7955 10.9692 10.7965 10.9804C10.8025 11.0989 10.7005 11.154 10.6284 11.2226C10.2062 11.623 9.78203 12.0225 9.35435 12.4182C9.15593 12.6021 8.95452 12.7813 8.84561 13.03H8.84461Z" fill="#5080A6"/>
                            <path d="M19.531 15.1684C19.532 15.1553 19.5325 15.1418 19.5315 15.1287C19.5827 15.0774 19.6339 15.026 19.6846 14.9747C20.2178 14.4791 20.7504 13.983 21.285 13.4888C21.3586 13.4207 21.4292 13.3115 21.552 13.3675C21.6569 13.4155 21.6281 13.5299 21.6281 13.6204C21.6306 14.6812 21.6321 15.7419 21.6336 16.8027C21.6162 16.8652 21.6336 16.9371 21.5764 16.9889C21.4943 17.0477 21.4322 16.995 21.3814 16.9478C20.7688 16.3803 20.1536 15.8157 19.5583 15.2318C19.5414 15.215 19.535 15.1912 19.531 15.1679V15.1684Z" fill="#A12426"/>
                            <path d="M10.8343 14.984C10.8323 14.97 10.8293 14.9565 10.8259 14.9425C10.8507 14.8454 10.9353 14.7899 11.0044 14.725C11.4291 14.3241 11.8543 13.9237 12.2825 13.5261C12.4868 13.3367 12.7017 13.1565 12.7788 12.8812C12.8956 13.0132 12.9275 13.1691 12.9275 13.3353C12.9275 14.3895 12.9275 15.4437 12.9275 16.4975C12.9275 16.5969 12.9473 16.7042 12.8215 16.7597C12.6907 16.7485 12.6276 16.6468 12.5475 16.5731C11.9751 16.0448 11.4057 15.5137 10.8353 14.9836L10.8343 14.984Z" fill="#1F6DB0"/>
                            <path d="M2.13532 15.1343C2.13184 15.1469 2.13135 15.159 2.13334 15.1716C2.11991 15.2556 2.05078 15.3042 1.99359 15.3583C1.44954 15.8703 0.905495 16.3817 0.359457 16.8909C0.283867 16.9614 0.21126 17.0402 0.0924051 17.0472C0.0411829 17.009 0.0531181 16.9516 0.0411829 16.9016C0.0426748 15.7475 0.0441667 14.5939 0.0456586 13.4398C0.160038 13.2643 0.257012 13.3927 0.336083 13.4655C0.726466 13.8234 1.10939 14.1888 1.49729 14.55C1.70814 14.7465 1.92298 14.9397 2.13582 15.1343H2.13532Z" fill="#006630"/>
                            <path d="M19.5311 15.1684C20.1328 15.671 20.6729 16.2324 21.2537 16.7546C21.3517 16.8424 21.4193 16.9716 21.5765 16.9894C21.5476 17.1821 21.4372 17.3319 21.295 17.4654C20.104 18.5821 18.9129 19.6989 17.7224 20.8161C17.6458 20.888 17.5712 20.9608 17.4514 20.9599C17.3897 20.8693 17.3957 20.7681 17.3957 20.6668C17.3957 19.3694 17.3986 18.0721 17.3932 16.7747C17.3922 16.5903 17.4479 16.448 17.5906 16.3201C17.89 16.0518 18.1799 15.7746 18.4698 15.4974C18.5827 15.3891 18.7225 15.313 18.8692 15.3639C19.1556 15.4624 19.3406 15.3233 19.5306 15.1693L19.5311 15.1684Z" fill="#B01020"/>
                            <path d="M0.0920787 17.0477C0.699285 16.4839 1.30649 15.9197 1.91469 15.3564C1.98432 15.292 2.0604 15.2332 2.13351 15.1716C2.32944 15.362 2.54478 15.4656 2.83918 15.363C2.95406 15.3228 3.05899 15.4026 3.14452 15.4834C3.47175 15.7919 3.79897 16.1003 4.12819 16.4069C4.23511 16.5063 4.27837 16.6225 4.27837 16.763C4.27638 18.0763 4.27688 19.3895 4.27738 20.7023C4.27738 20.7886 4.27539 20.8731 4.22218 20.9487C4.19035 20.9524 4.15852 20.9566 4.1267 20.9603C4.02674 20.9305 3.96457 20.8558 3.89445 20.7905C2.73475 19.704 1.57553 18.6167 0.41632 17.5298C0.269118 17.3921 0.127387 17.2516 0.0920787 17.0477Z" fill="#005926"/>
                            <path d="M12.7782 12.8816C12.7827 13.0076 12.7802 13.135 12.6773 13.2298C12.0596 13.8001 11.4713 14.3988 10.8258 14.9425C10.2037 14.3638 9.58055 13.7861 8.96091 13.2051C8.91018 13.1579 8.88283 13.0888 8.84454 13.03C8.8336 12.8606 8.92311 12.7402 9.04644 12.6254C9.63227 12.0794 10.2131 11.5292 10.7955 10.9804C11.4668 11.5544 12.0879 12.1756 12.7295 12.7776C12.7558 12.8023 12.7623 12.8466 12.7782 12.8816Z" fill="#18619A"/>
                            </svg>
                            <span style="flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-left: 10px;">View My Health Record</span>
                        </Button>
                        <MiniViewMhr v-if="mhrFile" :patient="this.patientInfo" @close="viewFMhrFile"/>
                        <button class="black-button" style="margin-left: 10px; font-weight: bold;" @click="closeModal()">Close</button>
                    </slot>
                </div>
            </div>
        </div>
        <SuccessModal v-if="displaySuccessModal" @close="closeSuccessModal" :message="successMessage.length ? successMessage : ''" :numActions="numActions" :actionsCompleted="actionsCompleted" :action="false" />
    </div>
</template>

<script>
import axios from 'axios';
import SuccessModal from './SuccessModal.vue';
import { applyTallmanLettering } from '@/services/TallmanLettering';
import MiniViewMhr from '../patientViewComponents/MiniViewMhr.vue';

export default {
    props: ['patientId', 'close', 'viewOnly', 'reviewedPrescription','patientInfo'],
    components: {
        SuccessModal,
        MiniViewMhr
    },
    data() {
        return {
            infoPrescriberTab : 'INFO',
            doseTimes: [],
            successMessage: [],
            displaySuccessModal: false,
            notes:'',
            do_not_crush:false,
            unusual_dose: false,
            unusual_qty: false,
            administration_options:[
                {value:'DO NOT CRUSH'},
                {value:'UNUSUAL DOSE'},
                {value:'UNUSUAL QTY'}
            ],
            drugList:[],
            stock:'',
            selectedDrug: {},
            drugSearchFilter: 0,
            numActions:0,
            actionsCompleted:0,
            packStatus: '',
            loadingCharts: false,
            patient: '',
            charts: '',
            activePresChart: '',
            draftDrug: '',
            isDraft: false,
            actionTypes: [
                'Packed',
                'Non-packed'
            ],
            wordNumber:'',
            dispensingApn: null,
            dispensingApnType: null,
            loadingGroups: false,
            loadingDrugs: false,
            packGroups:null,
            selectedCTPP: null,
            selectedPackSize: null,
            // flatPrescription: {}
            mhrFile:false
        }
    },
    methods: {
        closeSuccessModal(value){
            if(value){
                this.numActions = 0;
                this.actionsCompleted = 0;
                this.displaySuccessModal = false;
                this.$emit('close', true);
                // this.$emit('close', true);
            }
        },  
        submitReview(){
            this.$store.dispatch('getRefreshToken');
            this.numActions = 0;
            // SUBMIT CHART TAGS (PACKED/NON-PACKED/DNC);
            if(this.do_not_crush || this.unusual_dose || this.unusual_qty || this.packStatus){
                this.numActions += 1;
            }
            this.addChartTags();
            // SUBMIT AMT MED
            if(this.stock){
                this.numActions +=1;
            }
            this.submitAMT();
            // SUBMIT NOTES 
            if(this.notes){
                this.numActions += 1;
            }
            this.submitNote();
            
        },
        isSuccessful(value) {
            if (value) {
                // this.retrieveAllCharts();
                // this.$emit('markAsRead', this.notification_id);
            }
        },
        debounceSearchDrugs() {
            if (this.timeout)
                clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.searchDrugs()
            }, 400); // delayif (this.selectedCTPP) {
    
        },
        show(){
            console.log('HITING SAVE FUNCTION');
            let interval = setInterval(() => {
                console.log('HITTING INTERVAL');
                if (!this.loadingDrugs && this.drugList) {
                    clearInterval(interval);
                    this.$refs.med.show();
                }
            }, 100)
        },
        searchDrugs() {
            this.$store.dispatch('getRefreshToken');
            this.getAMTMeds();
        },
        drugSelect(item) {
            console.log('this is the drug item selected', item);
            this.selectedDrug.full_item = item;
            this.selectedDrug.drug_uuid = item.alias_id;
            this.selectedDrug.full_name = item.full_name;
            // this.selectedDrug.form = item.form ? item.form[0].toUpperCase() + item.form.slice(1) : '';
            this.selectedDrug.strength = `${item.strength}`;
            this.selectedDrug.measurement_unit = `${item.measurement_unit}`;
            
            let itemName = item.name;
            this.selectedDrug.name = itemName ? itemName[0].toUpperCase() + itemName.slice(1) : '';
            this.selectedDrug.tags = item.tags;
            this.loadingDrugs = false;
            if(item.drugs.length == 1){
                this.stock = item.drugs[0];
            }
            console.log('this is the selected drug item', this.selectedDrug);
        },
        closeModal() {
            console.log('hitting this closemodal function')
            this.$emit('close', true);
        },
        loadDispensingAPN() {
            // Dispensing apns are only handled here, in the dispensing workflow. One is only
            // needed for a streamlined authority item that has no prescriber generated number.
            const script = this.reviewedPrescription;
            if (!script || script.authority_prescription_number) {
                return;
            }
            if (!script.pbs_code || !script.pbs_authority_code) {
                return;
            }
            if (script.dispensing_apn) {
                this.dispensingApn = script.dispensing_apn;
                this.dispensingApnType = 'streamline';
                return;
            }
            axios.post('/dispensing-apn', { prescription_id: script.uuid }, this.$store.state.header).then(res => {
                this.dispensingApn = res.data.number;
                this.dispensingApnType = res.data.type;
            }).catch(err => {
                // Nothing to show the pharmacist if one can't be generated, e.g. a draft with
                // no prescriber assigned yet.
                console.log('could not retrieve dispensing apn', err.response?.data?.message || err.message);
            });
        },
        getCTPGroups(){
            this.loadingGroups = true;
            if (this.reviewedPrescription) {
                axios.post(`/get-pack-size-groups`, { prescription_id: this.reviewedPrescription.uuid }, this.$store.state.header).then(res => {
                    console.log('this is the amt data', res.data);
                    this.packGroups = res.data;
                    this.loadingGroups = false;
                })
            }
        },
        getAMTMeds(changingPackSize) {
            this.loadingDrugs = true;
            if (this.reviewedPrescription) {
                axios.post(`/get-dispensing`, { prescription_id: this.reviewedPrescription.uuid, name: this.selectedCTPP && !changingPackSize ? this.selectedCTPP.name ? this.selectedCTPP.name : this.selectedCTPP : '', pack_size: '' }, this.$store.state.header).then(res => {
                    console.log('this is the amt data', res.data);
                    res.data.forEach(drugGroup=>{
                        drugGroup.drugs.forEach(drug=>{
                            drug.pack_size_id = drugGroup.uuid;
                        })
                    })
                    
                    this.drugList = res.data;
                    this.loadingDrugs = false;
                })
            }
        },
        submitAMT(){
            if(this.stock){
                let payload = {
                    prescription_id: this.reviewedPrescription.uuid,
                    alias_id: this.stock.alias_id,
                    dispensed_item_id: this.stock.pack_size_id,
                    pack_size_id: this.stock.pack_size_id
                }
                this.displaySuccessModal = true;
                axios.post('/prescription/dispense', payload, this.$store.state.header).then(res=>{
                    console.log('updated amt data', res.data);
                    this.actionsCompleted +=1;
                }).catch(err=>{
                    console.log("couldn't submit notes", err.response.data);
                    this.successMessage.push('Failed to update dispense med data.');
                })
            }
            
        },
        submitNote(){
            if(this.notes){
                this.displaySuccessModal = true;
                axios.post(`/chart/${this.reviewedPrescription.chart_id}/add-note`, {note: this.notes}, this.$store.state.header).then(res=>{
                    console.log('submitted notes', res.data);
                    this.actionsCompleted += 1;
                }).catch(err=>{
                    console.log("couldn't submit notes", err.response.data);
                    this.successMessage.push('Failed to add chart notes.');
                })
            }
            
        },
        addChartTags(){
            if(this.do_not_crush || this.unusual_dose || this.unusual_qty || this.packStatus){
                let payloadArray = [];
                if(this.do_not_crush){
                    payloadArray.push('do not crush')
                }
                if(this.unusual_dose){
                    payloadArray.push('unusual dose')
                }
                if(this.unusual_qty){
                    payloadArray.push('unusual quantity')
                }
                if(this.packStatus){
                    payloadArray.push(this.packStatus)
                }
                this.displaySuccessModal = true;
                axios.post(`/chart/${this.reviewedPrescription.chart_id}/add-tags`, {tags:payloadArray}, this.$store.state.header).then(res=>{
                    console.log('this is the chart tag response', res.data);
                    this.actionsCompleted += 1;
                }).catch(err=>{
                    console.log("couldn't submit notes", err.response.data);
                    this.successMessage.push('Could not add chart tags.');
                })
            }
        },
        viewFMhrFile(){
            console.log("this is patient, ",this.patientInfo);
            this.mhrFile=!this.mhrFile;
        }

    },
    mounted() {
        // this.getCTPGroups();
        this.loadDispensingAPN();
        if(this.reviewedPrescription && this.reviewedPrescription.chart_tags && this.reviewedPrescription.chart_tags.length){
            
            this.reviewedPrescription.chart_tags.forEach(tag=>{
                if(tag.name == 'do not crush'){
                    this.do_not_crush = true;
                }
                if(tag.name == 'unusual dose'){
                    this.unusual_dose = true;
                }
                if(tag.name == 'unusual quantity'){
                    this.unusual_qty = true;
                }
                if(tag.name == 'packed'){
                    this.packStatus = 'Packed';
                    console.log('found packed tag', this.packStatus);
                }
                if(tag.name == 'non-packed'){
                    this.packStatus = 'Non-packed';
                    console.log('found non-packed tag', this.packStatus);
                }
            });       
            if(this.reviewedPrescription.chart_note && this.reviewedPrescription.chart_note.length){
                console.log('reviewed prescription has notes')
                this.notes = this.reviewedPrescription.chart_note[this.reviewedPrescription.chart_note.length -1].text
            }   
        }
        
        if(this.reviewedPrescription){
            this.getAMTMeds();
            this.reviewedPrescription.dose_times.forEach(time=>{
                this.doseTimes.push({"time": time.time, "day": time.day}); 
            })
        }

    },
    computed: {
        authorityNumber() {
            return this.reviewedPrescription?.authority_prescription_number || this.dispensingApn;
        },
        authorityNumberLabel() {
            if (this.reviewedPrescription?.authority_prescription_number || this.dispensingApnType == 'authority') {
                return 'Authority Prescription Number';
            }
            return 'Dispensing APN';
        },
        formattedDrugList() {
            let formattedList = [...this.drugList];
            formattedList.forEach(drug => {
                drug.name = drug.name ? applyTallmanLettering(drug.name) : '';
                drug.full_name = drug.ctpp && drug.ctpp !== drug.name ? `(${drug.name}) \u2013 ${drug.ctpp}` : drug.name;
            });
            return formattedList;
        },
        getPrimary() {
            return this.patient.prescribers.filter(item => item.primary_gp)
        },
        chart_tags(){
            return this.reviewedPrescription.chart_tags.filter(item=> !item.name.toLowerCase().startsWith('s4') && !item.name.toLowerCase().startsWith('s8') )
        },
        flatPrescription(){
            if(this.reviewedPrescription){
                return {
                    chart_type: this.reviewedPrescription.chart_type.split('_').join(' '),
                    generic: this.reviewedPrescription.alias_generic,
                    // strength: this.reviewedPrescription.alias.strength,
                    frequency: this.reviewedPrescription.frequency,
                    created_date: this.reviewedPrescription.created_date,
                    route: this.reviewedPrescription.route,
                    start_date: this.reviewedPrescription.start_date,
                    stop_date: this.reviewedPrescription.stop_date,
                    dose: this.reviewedPrescription.dose,
                    interval: this.reviewedPrescription.interval,
                    repeats: this.reviewedPrescription.repeats,
                    // chart_uuid: this.reviewedPrescription.chart.uuid,
                    max_dose: this.reviewedPrescription.max_dose,
                    // prescription_id: this.reviewedPrescription.prescription_id,
                    // alias_tags: this.reviewedPrescription.alias_tags,
                    prescription_type: this.reviewedPrescription.pbs_code ? 'PBS': 'Private',
                    brand_sub: this.reviewedPrescription.brand_sub,
                    authority_prescription_no: this.authorityNumber,
                    prescribed_quantity: this.reviewedPrescription.prescribed_quantity
                }
            } else{
                return null
            }
            
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

.label-with-icon {
    display: flex;
    align-items: center;
    border-radius: 10px;
    background-color: #f3f4f4;
    padding: 7px;
}

.label-with-icon i {
    font-size: 25px !important;
    color: #7b7e7e !important;
}

label {
    text-align: left;
    font-size: 16px;
}

.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

.right-form-section-drug-container {
    height: 250px;
    overflow-y: auto;
}

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}


.blue-button {
    background-color: $strongblue !important;
    padding: 5px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    color: white;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}

.patient-summary-block {
    .field-value {
        background-color: #f3f4f4;
    }
}

.chart-row-item {
    p {
        margin: 0;
        margin-top: 10px;
    }
}

#pharmacy-med-list_list{
    
    .p-dropdown-item{
        max-width: 45em;
        white-space: pre-wrap;
    }
}
</style>
